import script from "./SomethingWentWrongErrorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SomethingWentWrongErrorModal.vue?vue&type=script&setup=true&lang=ts"

import "./SomethingWentWrongErrorModal.vue?vue&type=style&index=0&id=0b9ac2cb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9ac2cb"]])

export default __exports__